import {
  getAuth,
  onAuthStateChanged,
  signInWithRedirect,
  signOut,
  User,
  signInWithPopup,
  OAuthProvider,
} from "firebase/auth";
import { app, config } from "@/app/firebase/config";
import { env } from "@/app/env";

const auth = getAuth(app);

const microsoftProvider = new OAuthProvider(
  "microsoft.com",
).setCustomParameters({
  tenant: env.NEXT_PUBLIC_MICROSOFT_OAUTH_TENANT_ID,
});

const handleLogin = async () => {
  if (window.location.hostname !== config.authDomain) {
    // The redirect method fails when running locally because of third-party
    // cookies/storage issues. See
    // <https://firebase.google.com/docs/auth/web/redirect-best-practices>.
    await signInWithPopup(auth, microsoftProvider);
  } else {
    await signInWithRedirect(auth, microsoftProvider);
  }
};

const handleLogout = async () => {
  await signOut(auth);
};

const getCurrentUser = (): Promise<User | null> => {
  const auth = getAuth();

  if (auth.currentUser) {
    return Promise.resolve(auth.currentUser);
  }

  return new Promise((resolve) => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      unsubscribe();
      resolve(user);
    });
  });
};

export { auth, handleLogin, handleLogout, getCurrentUser };
